export enum SETTLEMENT_ORDER_STATUS {
  waiting = 1,
  inProgress = 2,
  done = 3,
  error = 4,
  canceled = 5,
}
